import React from "react";
import './googleComponentsWrapper.scss';

function GoogleComponent() {

    return (
        <div>
            <div className="or-separator">
                <span className="separator"></span> <span data-group="SIGNUP" data-key="OR" className="separator-text">Or</span> 
                <span className="separator"></span>
            </div>
            <button className="core-button google-button" onClick={() =>false}>
                <div className="button-content">
                    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                        <path d="M23.5552 12.7897C23.5552 11.9753 23.4821 11.1922 23.3463 10.4404H12.5293V14.8831H18.7105C18.4442 16.3188 17.635 17.5352 16.4186 18.3496V21.2314H20.1305C22.3022 19.2319 23.5552 16.2875 23.5552 12.7897Z" fill="#4285F4"></path>
                        <path d="M12.5312 24.014C15.6323 24.014 18.2321 22.9856 20.1324 21.2314L16.4206 18.3497C15.3921 19.0388 14.0765 19.446 12.5312 19.446C9.53985 19.446 7.00787 17.4256 6.10471 14.7109H2.26758V17.6867C4.15743 21.4403 8.04154 24.014 12.5312 24.014Z" fill="#34A853"></path>
                        <path d="M6.10171 14.7103C5.87201 14.0211 5.74149 13.285 5.74149 12.5281C5.74149 11.7711 5.87201 11.035 6.10171 10.3458V7.37012H2.26459C1.46062 8.9706 1.04226 10.737 1.04297 12.5281C1.04297 14.3814 1.48672 16.1355 2.26459 17.686L6.10171 14.7103Z" fill="#FBBC05"></path>
                        <path d="M12.5312 5.61196C14.2175 5.61196 15.7315 6.19144 16.9218 7.32953L20.2159 4.03534C18.2269 2.18203 15.627 1.04395 12.5312 1.04395C8.04154 1.04395 4.15743 3.61769 2.26758 7.37129L6.10471 10.347C7.00787 7.63232 9.53985 5.61196 12.5312 5.61196Z" fill="#EA4335"></path>
                    </svg>
                    <span data-group="SIGNUP" data-key="CONTINUE_WITH_GOOGLE">Continue with Google</span>
                </div>
            </button>
        </div>
    )
}

export default GoogleComponent;